import React, { Component } from 'react';
import RegMobileWrapperContainer from '../containers/RegMobileWrapperContainer';

export default class UtilizationResultRegMobileView extends Component<any, any> {
  render() {
    return <RegMobileWrapperContainer {...this.props} />;
  }
}
